import { routes } from '@app/router/routes'
import type { LegalDocumentSlug } from '../types/legalTypes'

// Path builders other modules link with, so no caller hand-assembles `/legal/…`.
export function legalDocumentPath(slug: LegalDocumentSlug): string {
  return routes.LEGAL_DOCUMENT.replace(':slug', slug)
}

export const LEGAL_INDEX_PATH = routes.LEGAL
